import { el } from '../lib/dom.js';
import { Sprite } from './Sprite.js';
import { TypeChip } from './TypeChip.js';
import { typesForGen } from '../lib/type-resolve.js';

const STAT_ROWS = [
  ['hp', 'HP'],
  ['atk', 'Attack'],
  ['def', 'Defense'],
  ['spa', 'Sp. Atk'],
  ['spd', 'Sp. Def'],
  ['spe', 'Speed'],
];

/**
 * Side-by-side stat / type comparison of 2+ snapshot species. Each stat
 * row highlights the highest value; types are era-accurate for `gen`.
 */
export function CompareTable(members, { gen = 9, style } = {}) {
  const mem = members;
  const maxOf = (key) => Math.max(...mem.map((m) => m.stats?.[key] ?? 0));
  const row = (label, cells, cls = '') =>
    el('div', { class: `cmp__row ${cls}` }, el('span', { class: 'cmp__label' }, label), ...cells);

  return el(
    'div',
    { class: 'cmp' },
    row(
      '',
      mem.map((sp) =>
        el(
          'a',
          { class: 'cmp__mem', href: `#/pokemon/${sp.id}` },
          Sprite(sp.spriteId ?? sp.id, { style, size: 44, alt: sp.name }),
          el('span', {}, sp.name.replace(/-/g, ' ')),
        ),
      ),
      'cmp__row--head',
    ),
    row(
      'Type',
      mem.map((sp) => el('span', { class: 'cmp__cell' }, ...typesForGen(sp, gen).map(TypeChip))),
    ),
    ...STAT_ROWS.map(([key, label]) => {
      const mx = maxOf(key);
      return row(
        label,
        mem.map((sp) => {
          const v = sp.stats?.[key] ?? 0;
          const bar = el('span', { class: 'cmp__bar' });
          bar.style.width = `${(v / 200) * 100}%`;
          return el(
            'span',
            { class: `cmp__cell cmp__stat${v === mx ? ' is-max' : ''}` },
            el('span', { class: 'cmp__val' }, String(v)),
            el('span', { class: 'cmp__track' }, bar),
          );
        }),
      );
    }),
    row(
      'BST',
      mem.map((sp) => {
        const mx = Math.max(...mem.map((m) => m.bst || 0));
        return el(
          'span',
          { class: `cmp__cell cmp__stat${(sp.bst || 0) === mx ? ' is-max' : ''}` },
          el('span', { class: 'cmp__val' }, String(sp.bst || 0)),
        );
      }),
      'cmp__row--bst',
    ),
  );
}
